import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import React, { useEffect, useState } from 'react';
import ar from 'react-phone-number-input/locale/ar';
import en from 'react-phone-number-input/locale/en';

import { useTranslation } from 'react-i18next';
import { getLocation } from '../../Utils/UtilsFunctions';

const PhoneInternational = ({
  phoneNumber,
  setPhoneNumber,
  backgroundColor = '#f2f2f2',
  onBlur ,
  borderRadius = '5px',
  placeholder,
  error = false,
  onlyUS = false,
}) => {
  const [t, i18n] = useTranslation();
  const [countrycode, setcountrycode] = useState('');
  const labels = i18n.language === 'ar' ? ar : en;

  const phoneInputStyle = {
    width: '100%',
    padding: '12px 24px',
    fontSize: '16px',
    borderRadius: borderRadius,
    border: `1px solid ${error ? '#d32f2f' : '#e0e0e0'}`,
    boxShadow: error ? '0 0 0 1px rgba(211,47,47,0.2) inset' : 'none',
    
    backgroundColor: backgroundColor,
  };

  const countryOptionsOrder = onlyUS ? ['US'] : ['US', 'JO', 'EG'];
  const defaultcountry = 'US';

  const fetchLocation = async () => {
    const locationrespond = await getLocation();
    console.log("locations respond",locationrespond)
    setcountrycode(locationrespond);
  };
  useEffect(() => {
    fetchLocation();
  }, []);

  return (
    <PhoneInput
      labels={labels}
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultcountry}
      value={phoneNumber}
      onChange={setPhoneNumber}
      onBlur={onBlur}
      placeholder={placeholder}
      aria-invalid={error || undefined}
      countryOptionsOrder={countryOptionsOrder}
      countries={onlyUS ? ['US'] : undefined}
      style={{ ...phoneInputStyle }}

      //   countries={certaincountries}
      //   inputComponent={CustomPhoneNumberInput}
    />
  );
};

export default PhoneInternational;

const CustomPhoneNumberInput = React.forwardRef(
  ({ value, onChange, onFocus, onBlur, ...rest }, ref) => {
    const inputStyle = {
      width: '100%',
      padding: '10px',
      fontSize: '16px',
      borderRadius: '5px',
      backgroundColor: '#f2f2f2',
    };

    return (
      <input
        type="tel"
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={ref}
        style={inputStyle}
        {...rest}
      />
    );
  }
);
